<template>
  <div
    class="new-order-tariff-table"
    :class="componentClasses"
  >
    <div class="new-order-tariff-table__header">
      <sprite
        src="sprites_arrow-m-left"
        class="new-order-tariff-table__header-icon"
        @click="$router.go(-1)"
      />
      Выберите тариф
    </div>
    <div
      v-if="isWelcomeSetVisible"
      class="new-order-tariff-table__welcome-set"
      @click="goTo('/new-order-tariff/welcome-set')"
    >
      <img
        alt=""
        :src="welcomeSetImage"
        class="new-order-tariff-table__welcome-set-banner"
      >
      <p
        v-if="welcomeSetText"
        class="new-order-tariff-table__welcome-set-text"
        v-html="welcomeSetText"
      />
    </div>
    <div class="new-order-tariff-table__content">
      <div class="new-order-tariff-table__tariffs">
        <div
          v-for="{ key, name, minPrice, text, image, url, badgeText, badgeTextColor, badgeColor, priceTextColor } in tariffs"
          :key="key"
          :class="`new-order-tariff-table__card new-order-tariff-table__card--${key}`"
          @click="goTo(url)"
        >
          <div class="new-order-tariff-table__card-name">
            {{ name }}
            <sprite
              class="new-order-tariff-table__arrow"
              src="sprites_chevron_right"
            />
          </div>
          <SkeletonOneString
            v-if="!minPrice"
            :height="24"
            width="108px"
            :border-radius="8"
            class="new-order-tariff-table__skeleton-item"
          />
          <p
            v-else
            :class="`new-order-tariff-table__price new-order-tariff-table__price--${key}`"
            :style="{ color: priceTextColor }"
          >
            от {{ minPrice }} ₽/день
          </p>
          <p
            v-if="text"
            class="new-order-tariff-table__text"
            v-html="text"
          />
          <div
            v-if="badgeText"
            class="new-order-tariff-table__badge"
            :style="{ color: badgeTextColor, backgroundColor: badgeColor }"
          >
            {{ badgeText }}
          </div>
          <img
            class="new-order-tariff-table__card-image"
            alt=""
            :src="image"
          >
        </div>
      </div>
      <CompareTargetsTable
        v-if="tariffs.length > 1"
        class="new-order-tariff-table__info"
        :min-personal-price="minPersonalPrice"
        :min-economy-price="minEconomyPrice"
      />
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/core/Sprite'
import SkeletonOneString from '@/components/core/ui/SkeletonOneString'
import CompareTargetsTable from '@/components/core/lib/CompareTargetsTable'

import { mapVCP } from '@/services/mapVCP'
import { mapGetters } from 'vuex'
import { ECONOM_START_NAMES, TargetAssociations } from '@/config/constants'

export default {
  name: 'TariffTable',

  components: {
    Sprite,
    SkeletonOneString,
    CompareTargetsTable,
  },

  computed: {
    ...mapVCP({
      welcomeSetTariff: 'NewLandingVisual/TariffChoosing/WelcomeSetTariff',
      economyTariff: 'NewLandingVisual/TariffChoosing/EconomTariff',
      personalTariff: 'NewLandingVisual/TariffChoosing/PersonalTariff',
    }),

    ...mapGetters({
      targets: 'goals/goals',
    }),

    componentClasses () {
      return {
        'new-order-tariff-table--has-welcome-set': this.isWelcomeSetVisible,
      }
    },

    isWelcomeSetVisible () {
      return !!this.welcomeSetTariff?.active && this.welcomeSetImage
    },

    welcomeSetImage () {
      return this.welcomeSetTariff?.bannerImage
    },

    welcomeSetText () {
      return this.welcomeSetTariff?.bannerText
    },

    tariffs () {
      const tariffs = [
        {
          key: 'personal',
          name: 'Персональный',
          minPrice: this.minPersonalPrice,
          text: this.personalTariff?.bannerText,
          image: this.personalTariff?.bannerImage,
          url: '/new-order-tariff/personal/high',
          badgeText: this.personalTariff?.badgeText,
          badgeTextColor: this.personalTariff?.badgeTextColor,
          badgeColor: this.personalTariff?.badgeColor,
          priceTextColor: this.personalTariff?.priceTextColor,
        },
      ]
      const hasEconomyTariff = !!this.targets.find((goal) => goal.id === TargetAssociations.ECONOMY.ID)
      if (hasEconomyTariff) {
        tariffs.push({
          key: 'economy',
          name: 'Эконом',
          minPrice: this.minEconomyPrice,
          text: this.economyTariff?.bannerText,
          image: this.economyTariff?.bannerImage,
          url: '/new-order-tariff/economy/calories',
          badgeText: this.economyTariff?.badgeText,
          badgeTextColor: this.economyTariff?.badgeTextColor,
          badgeColor: this.economyTariff?.badgeColor,
          priceTextColor: this.economyTariff?.priceTextColor,
        })
      }
      return tariffs
    },

    minPersonalPrice () {
      return this.calculateMinPrice(false)
    },

    minEconomyPrice () {
      return this.calculateMinPrice(true)
    },
  },

  mounted () {
    window.scrollTo({ top: 0 })
  },

  methods: {
    goTo (url) {
      this.$router.push(url)
    },

    calculateMinPrice (isEconomy) {
      if (!this.targets?.length) {
        return 0
      }

      let price = Number.MAX_VALUE

      this.targets.forEach(target => {
        target.menuTypes.forEach(menuType => {
          const isExcluded = ['detox', 'breakfasts_2x'].includes(menuType.type)
          const isIncluded = isEconomy ? menuType.type.startsWith(ECONOM_START_NAMES) : !menuType.type.startsWith(ECONOM_START_NAMES)

          if (isExcluded || !isIncluded) {
            return
          }

          menuType.pricePlan.mealDays.forEach(mealDay => {
            const permanentSubscriptionPrice = mealDay.permanentSubscription?.price || price
            const mealDayPrice = Math.min(permanentSubscriptionPrice, mealDay.promoInfo.dayPrice)

            if (mealDayPrice < price) {
              price = mealDayPrice
            }
          })
        })
      })

      return price
    },
  },
}
</script>

<style lang="scss">
.new-order-tariff-table {
  background-color: #0F4128;

  &__skeleton-item {
    display: block;
    z-index: 1;

    &::after {
      animation: shimmer 1s infinite;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: white;
    position: fixed;
    right: 0;
    left: 0;
    z-index: 3;
    background-color: #0F4128;
  }

  &__header-icon {
    color: white;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 16px;
    top: 16px;
  }

  &__welcome-set {
    position: relative;
    cursor: pointer;
    margin-top: 56px;
  }

  &__welcome-set-banner {
    margin: 8px 0 24px;
    padding: 0 16px;
    width: 100%;
    height: auto;
  }

  &__welcome-set-text {
    position: absolute;
    top: 29%;
    left: 10%;
    font-size: 14px;
    line-height: 20px;
    color: white;
    z-index: 1;
  }

  &__content {
    background: #EBEBEB;
    border-radius: 24px 24px 0 0;
    padding: 16px 0 0;
    display: flex;
    flex-direction: column;
    gap: 36px;
    margin-top: 56px;
    height: 100vh;
  }

  &__tariffs {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
  }

  &__card {
    position: relative;
    background-color: map-get($colors, 'white');
    border-radius: 16px;
    cursor: pointer;
    padding: 20px;
    overflow: hidden;
  }

  &__card-name {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 24px;
    font-weight: 900;
    line-height: 28px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  &__arrow {
    height: 16px;
    width: 16px;
    fill: none;
    stroke: map-get($colors, 'grey_40');
  }

  &__card-image {
    position: absolute;
    top: 0;
    right: 0;
    width: auto;
    height: auto;
    max-height: 100%;
    object-fit: contain;
  }

  &__badge {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 12px;
    margin-top: 12px;
    height: 28px;
    width: fit-content;
    border-radius: 45px;
    background-color: map-get($colors, 'sunset_orange');
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: map-get($colors, 'white');
    z-index: 1;
  }

  &__price {
    position: relative;
    z-index: 1;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.2px;

    &--personal {
      color: map-get($colors, 'fun_green');
    }

    &--economy {
      color: map-get($colors, 'flamingo');
    }
  }

  &__text {
    position: relative;
    z-index: 1;
    font-size: 14px;
    line-height: 20px;
    margin-top: 12px;
  }

  &__info {
    padding: 36px 24px 48px;
  }

  &--has-welcome-set & {
    &__content {
      margin-top: -17px;
    }
  }
}
</style>
